import { useMemo } from 'react';
import { Typography } from '@mui/material';

import NumberTypo from 'src/components/common/Number';
import Image from 'src/components/Image';
import type { Validator } from 'src/types/validator';
import { times } from 'src/utils/number';

import {
  Base02TextContainer,
  Container,
  Divider,
  ImageContainer,
  LeftContainer,
  LeftTextContainer,
  RightCommissionContainer,
  RightContainer,
  ValidatorButton,
} from './styled';

import DefaultValidatorIcon from 'src/assets/svg/DefaultValidator.svg';

type ValidatorItemProps = {
  validatorInfo: Validator;
  rightText: string;
  rightValue?: string;
  onClick?: (walletInfo: Validator) => void;
};

export default function ValidatorItem({ validatorInfo, rightText, rightValue, onClick }: ValidatorItemProps) {
  const commission = useMemo(() => times(validatorInfo.commission.commission_rates.rate, '100'), [validatorInfo.commission.commission_rates.rate]);
  return (
    <Container>
      <Divider />
      <ValidatorButton
        onClick={() => {
          onClick?.(validatorInfo);
        }}
      >
        <LeftContainer>
          <ImageContainer>
            <Image
              src={`https://raw.githubusercontent.com/cosmostation/chainlist/main/chain/dydx/moniker/${validatorInfo.operator_address}.png`}
              defaultImgSrc={DefaultValidatorIcon}
            />
          </ImageContainer>
          <LeftTextContainer>
            <Typography variant="h3">{validatorInfo.description.moniker}</Typography>
          </LeftTextContainer>
        </LeftContainer>

        <RightContainer data-is-unstake={rightText === 'Staked'}>
          <RightCommissionContainer>
            <Base02TextContainer>
              <Typography variant="h9">{rightText}</Typography>
            </Base02TextContainer>
            &nbsp;
            {rightValue ? (
              <NumberTypo typoOfIntegers="h4" typoOfDecimals="h6">
                {rightValue}
              </NumberTypo>
            ) : (
              <Typography variant="h4">{commission}%</Typography>
            )}
          </RightCommissionContainer>
        </RightContainer>
      </ValidatorButton>
    </Container>
  );
}
